/**
 * メニュー項目のtype
 */
const MenuType = {
  // 通常
  NORMAL: 'normal',
  // 注意
  CAUTION: 'caution'
};
export { MenuType as default };
